module.exports = __webpack_public_path__ + "img/ic-pw.775811ed.svg";